/* @flow */

import getConfig from 'next/config';

import * as React from 'react';
import styled from 'styled-components';
import metaInfo from '../../../config/metaInfo';

import { Link } from '../../../routes';
import FlexBox from '../../../components/FlexBox';

const {
  publicRuntimeConfig: {
    logoLinkHref: LOGO_LINK_HREF,
  },
} = getConfig();

const { brands } = metaInfo;

const StyledLogo = styled(FlexBox)`
  border-radius: 6px;
  cursor: pointer;
  a {
    line-height: 100%;
  }
  img {
    width: ${({ locale }) => locale === 'cn' ? '48px' : '100px'};
    vertical-align: middle;
  }

  h1 {
    margin: 0;
    line-height: 0.8;
  }

  h1 a,
  h1 a:hover,
  h1 a:active,
  h1 a:visited {
    color: #f3bb2e;
  }
`;

export type Props = { locale: string};

const Logo = (props: Props) => {
  const { locale } = props;

  const logoSrc = locale === 'cn' ?
    require('../../../components/Logo/logo-cn.svg') :
    require('../../../components/Logo/logo-en.svg');

  return (
    <StyledLogo locale={locale} justify="center" direction="column">
      <Link route={LOGO_LINK_HREF.replace('%locale', locale)} prefetch={true}>
        <a draggable={false}>
          <img
            /* eslint-disable-next-line */
            src={logoSrc}
            alt={brands[locale]}
            draggable={false}
          />
        </a>
      </Link>
    </StyledLogo>
  );
};

export default Logo;
